module.exports = __webpack_public_path__ + "img/level-0.5ae42ce3.webp";